import { _,Obscura } from '../../vendor'

import InboomaBaseAsyncCollection from './InboomaBaseAsyncCollection'
import Voucher from '../models/Voucher'

const VouchersProxy = Obscura.extend({
    filterByTypeId (types) {
        return this.filterBy('voucher_type_id', (model) => model.get('voucher_type_id') && _.contains(types, model.get('voucher_type_id')));
    },
});

export default InboomaBaseAsyncCollection.extend({
    collectionName: 'vouchers',
    model: Voucher,
    url: '/vouchers',
    proxy: VouchersProxy,
    _pagination : {
        // Updated after each request (response.pagination)
        current_page : 0,
        sort : 'id',
        sortDirection : 'desc',
        has_next_page : false,
        has_prev_page : false,
        count : 0, // not relevant; response total entities count
        limit : 300
    },
});